import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { ThemeProvider, withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import newTheme from 'themes/theme';
import styles from './styles';

const FooterTerms = ({ classes }) => (
  <ThemeProvider theme={newTheme}>
    <CssBaseline />
    <Grid
      component="footer"
      container
      className={classes.wrapper}
    >
      <main className={classes.main}>
        <p className={classes.terms}>
          NONOPWELLS, INC. (“NOW”) is not a FINRA member. Securities are
          offered through PEP Advisory LLC, d/b/a Pickering Energy Partners
          (“PEP”), with which NOW has an independent, registered representative,
          business and software license agreement, for purposes of offering oil
          and gas interests to institutional-only customers through NOW’s
          proprietary web-based, sealed bid auction marketplace.
        </p>
        <p className={classes.terms}>
          PEP Advisory LLC, which provides compliance support and supervision to
          NOW, is a member of
          {' '}
          <a
            href="https://www.finra.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            FINRA
          </a>
          . PEP Advisory LLC is also a member of the
          {' '}
          <a
            href="https://www.sipc.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Securities Investor Protection Corporation (SIPC)
          </a>
          . You may obtain information about SIPC, including the SIPC brochure,
          by contacting SIPC at (202) 371-8300. More information is available at
          {' '}
          <a
            href="https://brokercheck.finra.org/firm/summary/166636"
            target="_blank"
            rel="noopener noreferrer"
          >
            BrokerCheck
          </a>
          .
        </p>
        <p className={classes.terms}>
          DISCLAIMER: THE INFORMATION CONTAINED IN THIS WEBSITE IS FOR
          INFORMATIONAL PURPOSES ONLY AND IS NOT INTENDED, AND SHOULD NOT BE
          USED OR CONSTRUED, AS AN OFFER TO SELL, OR A SOLICITATION OF ANY OFFER
          TO BUY, ANY SECURITY. NO SUCH OFFER OR SOLICITATION MAY BE MADE PRIOR
          TO THE DELIVERY OF DEFINITIVE OFFERING DOCUMENTATION. THE INFORMATION
          IN THIS WEBSITE IS NOT INTENDED AND SHOULD NOT BE CONSTRUED AS
          INVESTMENT, FINANCIAL, OR OTHER ADVICE.
        </p>
      </main>
    </Grid>
  </ThemeProvider>
);

FooterTerms.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default compose(withStyles(styles), memo)(FooterTerms);
